import {DateTime, Interval} from "luxon";
import rootStore from "../store";

export function formatPercent(percent: number) {
    return percent ? (percent * 100).toFixed(0) + '%' : '0%';
}

export function formatTime(time: string, fallbackText?: string) {
    return time 
        ? DateTime.fromISO(time, { zone: rootStore.state.facility.ianaTimeZoneName })
            .toLocaleString(DateTime.TIME_SIMPLE) 
        : (fallbackText || 'Unknown');
}

export function formatShortDate(isoDate: string, fallbackText?: string) {
    return isoDate 
        ? DateTime.fromISO(isoDate, {zone: rootStore.state.facility.ianaTimeZoneName})
            .toLocaleString(DateTime.DATE_SHORT) 
        : (fallbackText || 'Unknown');
}

export function formatLongDateTime(isoDateTime: string|undefined, fallbackText?: string) {
    if (!isoDateTime) return (fallbackText || 'Unknown');

    const dateTime = DateTime.fromISO(isoDateTime, { zone: rootStore.state.facility.ianaTimeZoneName });
    return `${dateTime.toLocaleString(DateTime.DATE_HUGE)} at ${dateTime.toLocaleString(DateTime.TIME_SIMPLE)}`
}

export function formatShortDateTime(isoDate: string|undefined, fallbackText?: string) {
    return isoDate 
        ? DateTime.fromISO(isoDate, {zone: rootStore.state.facility.ianaTimeZoneName})
            .toLocaleString(DateTime.DATETIME_SHORT) 
        : (fallbackText || 'Unknown');
}

export function formatTimeSince(isoDate: string) {
    if (!isoDate) return 'never';
    const interval = Interval.fromDateTimes(DateTime.fromISO(isoDate, 
        {zone: rootStore.state.facility.ianaTimeZoneName}), 
    DateTime.local().setZone(rootStore.state.facility.ianaTimeZoneName));
    return interval.length('minutes') < 5 ? ' just now'
        : interval.length('minutes') < 91 ? Math.ceil(interval.length('minutes')) + ' minutes ago'
            : interval.length('hours') < 25 ? Math.ceil(interval.length('hours')) + ' hours ago'
                : interval.length('days') < 15 ? Math.ceil(interval.length('days')) + ' days ago'
                    : interval.length('weeks') < 9 ? Math.ceil(interval.length('weeks')) + ' weeks ago'
                        : interval.length('months') < 25 ? Math.ceil(interval.length('months')) + ' months ago'
                            : Math.ceil(interval.length('years')) + ' years ago';
}
